'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';

const GalleryGrid = ({ images }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const closeLightbox = () => setActiveIndex(null);

  const showPrev = () => {
    if (activeIndex === null || images.length === 0) {
      return;
    }

    setActiveIndex((activeIndex - 1 + images.length) % images.length);
  };

  const showNext = () => {
    if (activeIndex === null || images.length === 0) {
      return;
    }

    setActiveIndex((activeIndex + 1) % images.length);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (activeIndex === null) {
        return;
      }

      if (event.key === 'Escape') {
        closeLightbox();
      }

      if (event.key === 'ArrowLeft') {
        showPrev();
      }

      if (event.key === 'ArrowRight') {
        showNext();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeIndex]);

  if (!images.length) {
    return (
      <div data-component-id="src/components/common/GalleryGrid.jsx:52:6" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="52" data-component-end-line="54" data-component-file="GalleryGrid.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20py-16%20text-gray-500%22%2C%22textContent%22%3A%22No%20gallery%20images%20found.%22%7D" className="text-center py-16 text-gray-500">
        No gallery images found.
      </div>
    );
  }

  return (
    <>
      <div data-component-id="src/components/common/GalleryGrid.jsx:60:6" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="60" data-component-end-line="82" data-component-file="GalleryGrid.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-6%20md%3Agap-8%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {images.map((image, index) => (
          <button data-component-id="src/components/common/GalleryGrid.jsx:62:10" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="62" data-component-end-line="80" data-component-file="GalleryGrid.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22group%20bg-gray-900%20rounded-lg%20h-60%20md%3Ah-64%20lg%3Ah-72%20relative%20overflow-hidden%20text-left%22%7D"
            type="button"
            key={image.src}
            className="group bg-gray-900 rounded-lg h-60 md:h-64 lg:h-72 relative overflow-hidden text-left"
            onClick={() => setActiveIndex(index)}
            aria-label={`Open image ${index + 1}`}
          >
            <Image data-component-id="src/components/common/GalleryGrid.jsx:69:12" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="69" data-component-end-line="75" data-component-file="GalleryGrid.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-cover%20transition-transform%20duration-300%20group-hover%3Ascale-105%22%7D"
              src={image.src}
              alt={image.alt}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              className="object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div data-component-id="src/components/common/GalleryGrid.jsx:76:12" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="76" data-component-end-line="76" data-component-file="GalleryGrid.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-t%20from-gray-900%2F60%20to-transparent%20opacity-80%22%7D" className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent opacity-80"></div>
            <span data-component-id="src/components/common/GalleryGrid.jsx:77:12" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="77" data-component-end-line="79" data-component-file="GalleryGrid.jsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20left-4%20bottom-3%20text-white%20text-sm%20font-medium%22%2C%22textContent%22%3A%22%2F%22%7D" className="absolute left-4 bottom-3 text-white text-sm font-medium">
              {index + 1}/{images.length}
            </span>
          </button>
        ))}
      </div>

      {activeIndex !== null && (
        <div data-component-id="src/components/common/GalleryGrid.jsx:85:8" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="85" data-component-end-line="138" data-component-file="GalleryGrid.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-%5B100%5D%20bg-black%2F90%20p-4%20md%3Ap-8%20flex%20items-center%20justify-center%22%7D"
          className="fixed inset-0 z-[100] bg-black/90 p-4 md:p-8 flex items-center justify-center"
          role="dialog"
          aria-modal="true"
          aria-label="Image preview"
          onClick={closeLightbox}
        >
          <button data-component-id="src/components/common/GalleryGrid.jsx:92:10" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="92" data-component-end-line="99" data-component-file="GalleryGrid.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22absolute%20top-5%20right-5%20text-white%2F90%20hover%3Atext-white%20text-3xl%20leading-none%22%2C%22textContent%22%3A%22%C3%97%22%7D"
            type="button"
            className="absolute top-5 right-5 text-white/90 hover:text-white text-3xl leading-none"
            onClick={closeLightbox}
            aria-label="Close image preview"
          >
            ×
          </button>

          <button data-component-id="src/components/common/GalleryGrid.jsx:101:10" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="101" data-component-end-line="111" data-component-file="GalleryGrid.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22absolute%20left-3%20md%3Aleft-8%20h-12%20w-12%20rounded-full%20bg-white%2F20%20text-white%20text-2xl%20hover%3Abg-white%2F30%22%2C%22textContent%22%3A%22%E2%80%B9%22%7D"
            type="button"
            className="absolute left-3 md:left-8 h-12 w-12 rounded-full bg-white/20 text-white text-2xl hover:bg-white/30"
            onClick={(event) => {
              event.stopPropagation();
              showPrev();
            }}
            aria-label="Previous image"
          >
            ‹
          </button>

          <div data-component-id="src/components/common/GalleryGrid.jsx:113:10" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="113" data-component-end-line="125" data-component-file="GalleryGrid.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20max-w-6xl%20h-%5B60vh%5D%20sm%3Ah-%5B68vh%5D%20md%3Ah-%5B75vh%5D%22%7D"
            className="relative w-full max-w-6xl h-[60vh] sm:h-[68vh] md:h-[75vh]"
            onClick={(event) => event.stopPropagation()}
          >
            <Image data-component-id="src/components/common/GalleryGrid.jsx:117:12" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="117" data-component-end-line="124" data-component-file="GalleryGrid.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%22%7D"
              src={images[activeIndex].src}
              alt={images[activeIndex].alt}
              fill
              sizes="100vw"
              className="object-contain"
              priority
            />
          </div>

          <button data-component-id="src/components/common/GalleryGrid.jsx:127:10" data-component-path="src/components/common/GalleryGrid.jsx" data-component-line="127" data-component-end-line="137" data-component-file="GalleryGrid.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-3%20md%3Aright-8%20h-12%20w-12%20rounded-full%20bg-white%2F20%20text-white%20text-2xl%20hover%3Abg-white%2F30%22%2C%22textContent%22%3A%22%E2%80%BA%22%7D"
            type="button"
            className="absolute right-3 md:right-8 h-12 w-12 rounded-full bg-white/20 text-white text-2xl hover:bg-white/30"
            onClick={(event) => {
              event.stopPropagation();
              showNext();
            }}
            aria-label="Next image"
          >
            ›
          </button>
        </div>
      )}
    </>
  );
};

export default GalleryGrid;
